<nav class="sidebar" [style.width.px]="width()">
  <!-- Logo -->
  <div class="sidebar-brand">
    <div class="brand-icon">
      <mat-icon>mark_email_read</mat-icon>
    </div>
    <div>
      <div class="brand-name">PEC Engine</div>
      <div class="brand-sub">Enterprise intelligence</div>
    </div>
  </div>

  <!-- Compose -->
  <div class="sidebar-compose">
    <button class="compose-btn" (click)="state.openCompose()">
      <mat-icon>edit_square</mat-icon>
      <span>Nuovo messaggio</span>
    </button>
  </div>

  <!-- Navigation -->
  <div class="sidebar-nav">
    <div class="section-label">Navigazione</div>
    @for (item of sidebarItems(); track item.id) {
      <button class="nav-item" [class.is-active]="isViewActive(item)" (click)="handleRoute(item)">
        <span [innerHTML]="getIcon(item.icon)"></span>
        <span class="nav-label">{{ item.label }}</span>
        @if (item.id == 'sent') {
          <span class="nav-count" [class.nav-count-active]="isViewActive(item)">
            PEC_WG
          </span>
        }
        <!-- COUNTER DISATTIVATI
        @if (
          item.id === 'inbox' &&
          mailService.inboxCountFor(mailboxService.casellaMonitorataEmail()) > 0
        ) {
          <span class="nav-count" [class.nav-count-active]="isViewActive(item)">{{
            mailService.inboxCountFor(mailboxService.casellaMonitorataEmail())
          }}</span>
        }
        -->
      </button>

      <!-- Etichette della sezione (Inbox/Archivio), visibili quando la voce è attiva -->
      @if (hasEtichette(item.id) && isViewActive(item)) {
        <div class="nav-subitems">
          @for (etichetta of etichetteFor(item.id); track etichetta.id) {
            <button
              class="nav-subitem"
              [class.is-active]="isEtichettaSelected(etichetta.id)"
              (click)="selectEtichetta(etichetta)"
            >
              <span class="nav-subitem-dot"></span>
              <span class="nav-subitem-label">{{ etichetta.nomeEtichetta }}</span>
            </button>
          } @empty {
            <div class="nav-subitems-empty">Nessuna etichetta</div>
          }
        </div>
      }
    }
  </div>

  <!-- Mailboxes -->
  <div class="sidebar-section">
    <div class="section-label">Caselle monitorate</div>
    @for (mb of mailboxService.mailboxes(); track mb.email) {
      <button
        class="mailbox-item"
        [matTooltip]="mb.email"
        [class.is-active]="isMailboxSelected(mb.email)"
        (click)="navigateToMailbox(mb)"
      >
        <span class="mailbox-dot" [class.peo]="mb.tipo === 'PEO'"></span>
        <span class="mailbox-addr">{{ mb.email }}</span>
        @if (isMailboxSyncing(mb.email)) {
          <mat-progress-spinner
            class="mailbox-sync-icon"
            [diameter]="12"
            [strokeWidth]="2"
            mode="indeterminate"
            [matTooltip]="'Sincronizzazione in corso'"
          />
        }
        <span class="pec-type-chip pec-type-pec">PEC</span>
        <!-- COUNTER DISATTIVATI <span class="mailbox-unread">{{ mailService.inboxCountFor(mb.email) }}</span> -->
      </button>
    }
  </div>

  <!-- User footer -->
  <div class="sidebar-footer">
    <div class="sidebar-nav">
      @for (item of footerNavItems; track item.id) {
        <button class="nav-item" [class.is-active]="isViewActive(item)" (click)="handleRoute(item)">
          <span [innerHTML]="getIcon(item.icon)"></span>
          <span class="nav-label">{{ item.label }}</span>
        </button>
      }
    </div>

    <button class="user-btn" [matMenuTriggerFor]="userMenu">
      <div class="user-avatar">{{ getUserInitials() }}</div>
      <div class="user-info">
        <span class="user-name">{{ getUser()?.user }}</span>
        <span class="user-role">{{ getUser()?.ruolo }}</span>
      </div>
      <div class="status-dot"></div>
    </button>

    <mat-menu #userMenu="matMenu" class="user-menu">
      <button mat-menu-item [matMenuTriggerFor]="accentMenu">
        <mat-icon>palette</mat-icon>
        Tema colori
      </button>
      <mat-divider />
      <button mat-menu-item (click)="doLogout()">
        <mat-icon>logout</mat-icon>
        Disconnetti
      </button>
    </mat-menu>

    <mat-menu #accentMenu="matMenu">
      @for (name of accentNames; track $index) {
        <button mat-menu-item (click)="theme.setAccent(name)">
          <span class="accent-swatch" [style.background]="theme.getAccentColor(name)"></span>
          {{ name | titlecase }}
          @if (theme.accent() === name) {
            <mat-icon class="check-icon">check</mat-icon>
          }
        </button>
      }
    </mat-menu>
  </div>
</nav>
<div
  class="sidebar-resizer"
  role="separator"
  aria-orientation="vertical"
  aria-label="Ridimensiona la barra laterale"
  (pointerdown)="startResize($event)"
  (dblclick)="resetWidth()"
></div>
